import React, { forwardRef, type Ref } from 'react';
import { useFieldProps } from '../../contexts/field-props-context';
import { Field } from '../field';
import { type BaseFieldProps } from './base-field-props';
import { BaseRequired } from './base-required';

interface BaseLabelProps {
  children: React.ReactNode;
  asChild?: boolean;
  className?: string;
}

export const BaseLabelRoot = <T extends BaseFieldProps>(
  props: BaseLabelProps,
  ref: Ref<HTMLDivElement>,
) => {
  const { children, asChild, className } = props;

  const { id, label, showLabel } = useFieldProps<T>();
  if (!showLabel) {
    return null;
  }

  return (
    <Field.Label ref={ref} asChild={asChild}>
      <label htmlFor={id} className={className}>
        {label}
        {children}
      </label>
    </Field.Label>
  );
};

const BaseLabelForward = forwardRef(BaseLabelRoot) as typeof BaseLabelRoot;

export interface BaseLabelComponent<T extends BaseFieldProps>
  extends React.ForwardRefExoticComponent<
    BaseLabelProps & React.RefAttributes<HTMLDivElement>
  > {
  Required: typeof BaseRequired<T>;
}

export const BaseLabel = BaseLabelForward as BaseLabelComponent<BaseFieldProps>;

BaseLabel.Required = BaseRequired;
